// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__18e14","button":"styles_button__3EBCO"};